import Cookies from 'js-cookie';
import BaseUrl from '../../types/BaseUrl';
import ICampaignID from '../../types/ICampaignID';
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";

// Class to work with cookie as a campaing UUID container
export default class CampaignInfoCookieContainer implements ICampaignInfoContainer {
  readonly containerName = 'cookie';
  readonly parameterName = 'campaign_uuid';
  private cookieDomain: string;
  private readonly validDays = 30;

  constructor(baseUrl: BaseUrl) {
    this.cookieDomain = `.${baseUrl.getDomain()}`;
  }

  load() {
    const result: ICampaignID = {
      UUID: Cookies.get(this.generateCookieName()),
      container: this.containerName
    };

    return result.UUID ? result : null;
  }

  store (campaignId: ICampaignID) {
    const cookieConfig: Cookies.CookieAttributes = { expires: this.validDays, domain: this.cookieDomain };
    if (!!campaignId && ["param", "referrer"].indexOf(campaignId.container) > -1) {
      Cookies.set(this.generateCookieName(), campaignId.UUID, cookieConfig);

      return true;
    }
    //set the cookie and default it so that auto populate works in checkout etc
    if (!this.load() && !campaignId) {
      Cookies.set(this.generateCookieName(), "merchandising", cookieConfig);
      return false;
    }

    return false;
  }

  private generateCookieName(): string {
    return this.parameterName;
  }
}